import { render, staticRenderFns } from "./Imofalform5FormHeader.vue?vue&type=template&id=0b38240c"
import script from "./Imofalform5FormHeader.vue?vue&type=script&lang=js"
export * from "./Imofalform5FormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports